import React from 'react';
import i18n from 'i18n';
import PropTypes from 'prop-types';

export const UrlLinkError = ({ title, explanation }) => {
  return (
    <>
      <div className="brityworks apply">
        <div className="header">
          <div className="logo" />
        </div>
        <div className="container no-use">
          <div className="welcome_area lang-ko">
            <div className="img" />
            <h1>{title}</h1>
            <div className="exp">{explanation}</div>
          </div>
        </div>
      </div>
    </>
  );
};

UrlLinkError.propTypes = {
  title: PropTypes.string,
  explanation: PropTypes.string,
};

UrlLinkError.defaultProps = {
  title: i18n.t('MB_M_LINK_FAIL_TITLE'),
  explanation: (
    <>
      {i18n.t('MB_M_LINK_FAIL1')}
      <br />
      {i18n.t('MB_M_LINK_FAIL2')}
    </>
  ),
};

export default UrlLinkError;
